import * as React from "react";
import {Grid2 as Grid, Typography} from "@mui/material";
import {CardEx} from "@/lib/components/CardEx";
import {useTranslation} from "react-i18next";
import {RequestI18N} from "@/translations";
import {RecipientScopeDTO, RequestRecipientMode} from "@/api/data-contracts";

export type RecipientScopeCardProps = {
    recipientScope?: RecipientScopeDTO | null;
};

/**
 * Read-only display of a published request's recipient scope ("Empfängerkreis"): no input fields, no
 * buttons, the scope cannot be changed after publication (Festlegung 6). Mode ALL shows only the summary
 * line, mode SELECTED shows the count in the summary line plus the name of every selected company. The
 * server already returns the companies alphabetically ordered by name, this card renders them in that
 * order without sorting again.
 */
export const RecipientScopeCard = ({ recipientScope }: RecipientScopeCardProps) => {
    const { t } = useTranslation();

    if (!recipientScope) {
        return null;
    }

    const companies = recipientScope.companies ?? [];
    const isSelected = recipientScope.mode === RequestRecipientMode.SELECTED;

    return (
        <CardEx title={t(RequestI18N.details.recipientScope.title)}>
            <Grid container spacing={1}>
                <Grid size={{ sm: 12 }}>
                    <Typography variant="body2">
                        {isSelected
                            ? t(RequestI18N.details.recipientScope.modeSelected, { count: companies.length })
                            : t(RequestI18N.details.recipientScope.modeAll)}
                    </Typography>
                </Grid>
                {isSelected &&
                    companies.map((company) => (
                        <Grid size={{ sm: 12 }} key={company.id}>
                            <Typography variant="body2" color="text.secondary">
                                {company.name}
                            </Typography>
                        </Grid>
                    ))}
            </Grid>
        </CardEx>
    );
};
